import {takeEvery} from 'redux-saga/effects'

import {
  GET_ACCOUNT,
  GET_ACTIVE_USER,
  GET_ACTIVITIES_USER,
  GET_ATTENDANCE,
  GET_BRANCH_LOGO,
  GET_CURRENT_SESSION,
  GET_DASHBOARD_FEE_STATS,
  GET_FEED,
  GET_NEWS,
  GET_SCHEDULE,
  GET_STATS,
  GET_USER_PREFERENCES,
  GET_USER_STATISTICS,
  UPDATE_USER_PREFERENCES,
} from '../../Actions/Dashboard/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_STATS, fetchData)
  yield takeEvery(GET_FEED, fetchData)

  yield takeEvery(GET_ACTIVE_USER, fetchData)
  yield takeEvery(GET_ACTIVITIES_USER, fetchData)
  yield takeEvery(GET_ATTENDANCE, fetchData)
  yield takeEvery(GET_NEWS, fetchData)
  yield takeEvery(GET_ACCOUNT, fetchData)
  yield takeEvery(GET_DASHBOARD_FEE_STATS, fetchData)
  yield takeEvery(GET_SCHEDULE, fetchData)

  yield takeEvery(GET_BRANCH_LOGO, fetchData)
  yield takeEvery(GET_USER_PREFERENCES, fetchData)
  yield takeEvery(UPDATE_USER_PREFERENCES, fetchData)

  yield takeEvery(GET_CURRENT_SESSION, fetchData)

  yield takeEvery(GET_USER_STATISTICS, function* (action) {
    yield fetchData(action)
  })

}

export default dataSaga
